import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { gray, secondary, white, tertiary } from '~/components/mixins/color';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0px;
`;

const Group = styled.div`
  display: grid;
  position: relative;
  margin: ${props => props.noMargin ? '0' : '0 0 10px'};
  width: 100%;
  min-width: 0px;

  textarea {
    background: ${secondary.hex()};
    border: 2px solid ${tertiary.hex()};
    border-radius: 3px;
    padding: 22px 0 8px 10px;
    color: ${gray.hex()};
    transition: border-color 0.2s ease-in 0s;
    resize: none;
    min-width: 0px;

    & + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
      color: ${white.hex()};
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      color: ${gray.hex()};
      opacity: 0.75;
    }
  }

  input {
    background: ${secondary.hex()};
    border: 2px solid ${secondary.hex()};
    border-radius: 3px;
    padding: 19px 40px 6px 10px;
    color: ${gray.hex()};
    position: relative;
    transition: border-color 0.2s ease-in 0s;
    min-width: 0px;

    & + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
      color: ${white.hex()};
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      color: ${gray.hex()};
      opacity: 0.75;
    }
  }
`;

const InputLabel = ({ label, value, rows, noMargin }) => (
  <Container>
    <Group noMargin={noMargin}>
      { rows ?
        <textarea
          placeholder={label}
          value={value || ''}
          disabled={true}
          />
        :
        <input
          type="text"
          placeholder={label}
          value={value || ''}
          disabled={true}
        />
      }
      <label htmlFor={label}>{label}</label>
    </Group>
  </Container>
);

InputLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default InputLabel;
